import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Container, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { useNewPatientContext } from "../store/NewPatientContextProvider";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: "#333",
  background: "#fff",
  margin: theme.spacing(1),
  marginLeft: 0,
  marginTop: 0,
}));

const style = {
  background: "#fff",
  width: "fit-content",
  p: 4,
  color: "#333",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const DIVIDER_STYLE = {
  width: "100%",
  background: "#777",
  margin: "10px 0",
  height: 3,
};

export default function Label() {
  const { newPatient } = useNewPatientContext();
  const { Branch, FirstName, LastName, PhoneNumber } =
    newPatient.PatientDetails;

  const handlePrintClick = (e) => {
    e.currentTarget.style.display = "none";
    window.print();
    e.currentTarget.style.display = "block";
  };

  return (
    <>
      <Helmet>
        <title>lable</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          background: "#fff",
        }}
      >
        <Box sx={style}>
          <Container
            component="main"
            maxWidth="xs"
            sx={{
              boxShadow: (theme) => theme.shadows[1],
              paddingTop: 3,
              paddingBottom: 3,
              cursor: "default",
              background: "#fff !important",
              width: "fit-content",
            }}
          >
            <Button
              color="secondary"
              variant="outlined"
              fullWidth
              onClick={handlePrintClick}
            >
              Print Label
            </Button>

            <br />
            <br />

            <Grid container>
              <Grid item xs={4} md={4}>
                <div style={{ fontWeight: 900, color: "#333" }}>
                  xxxxxxxxxxxx
                </div>
              </Grid>
              <Grid item xs={4} md={4}>
                <div
                  style={{
                    textAlign: "center",
                    fontWeight: 900,
                    color: "#333",
                  }}
                >
                  xxxxxxxxxxxx
                </div>
              </Grid>
              <Grid item xs={4} md={4}>
                <div
                  style={{ textAlign: "end", fontWeight: 900, color: "#333" }}
                >
                  xxxxxxxxxxxx
                </div>
              </Grid>
            </Grid>

            <h4 style={{ textAlign: "center" }}> DIAGNOSTIC RADIOLOGIST </h4>

            <div style={DIVIDER_STYLE} />

            <h4> BRANCH : {Branch} </h4>

            <div style={DIVIDER_STYLE} />

            <Grid container>
              <Grid item xs={6} md={6}>
                <Item>
                  <b> NAME </b> : {FirstName + " " + LastName}
                </Item>
              </Grid>

              <Grid item xs={6} md={6}>
                <Item>
                  <b> ACC NO. </b> : XXXXXX
                </Item>
              </Grid>

              <Grid item xs={6} md={6}>
                <Item>
                  <b> TEL </b> : {PhoneNumber}
                </Item>
              </Grid>

              <Grid item xs={6} md={6}>
                <Item>
                  <b> DATE </b> : {new Date().toDateString()}
                </Item>
              </Grid>

              <Grid item xs={6} md={6}>
                <Item>
                  <b> REFERRED BY </b> : XXXXXX
                </Item>
              </Grid>
            </Grid>

            <div style={DIVIDER_STYLE} />

            <h4 style={{ textAlign: "center" }}> EXAMINATION/ONDERSOEK </h4>
          </Container>
        </Box>
      </Box>
    </>
  );
}
